import { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner, Table } from "react-bootstrap";
import { BsWechat } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import reviewerApi from "../../../api/reviewerApi";

const Reviwers = ({ documentId, documentName }) => {
  const [reviewers, setReviewers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [newReviewer, setNewReviewer] = useState({
    email: "",
  });

  useEffect(() => {
    if (documentId) {
      reviewerApi
        .getDetailsOfReviewerById(documentId)
        .then((response) => {
          setReviewers(response.data || []);
          setLoading(false);
        })
        .catch((err) => {
          setError("Failed to fetch reviewer details.");
          console.error("Error fetching reviewers:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [documentId]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  const handleChatClick = (reviewer) => {
    navigate("/dashboard/chat-app-reviewers", {
      state: {
        documentId,
        documentName,
        chatType: "document",
        reviewerEmail: reviewer.email,
        activeSidebar: "/dashboard/my-consents",
      },
    });
  };

  const handleAddReviewerClick = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setNewReviewer({ email: "" });
  };
  const handleSaveAddReviewer = async () => {
    const email = newReviewer.email.trim().toLowerCase();

    if (!email) {
      Swal.fire("Error", "Please enter a reviewer email.", "error");
      return;
    }

    const isDuplicate = reviewers.some(
      (reviewer) => reviewer.email?.trim().toLowerCase() === email,
    );

    if (isDuplicate) {
      Swal.fire({
        icon: "error",
        title: "Duplicate Reviewer",
        text: "This reviewer has already been added.",
      });
      return;
    }

    try {
      const payload = {
        email,
      };

      const response = await reviewerApi.AddReviewer(documentId, payload);

      const savedReviewer = response.data;

      setReviewers((prev) => [
        ...prev,
        {
          id: savedReviewer.id,
          email: savedReviewer.email,
          approved: savedReviewer.approved === true,
          approvedAt: savedReviewer.approvedAt || "N/A",
        },
      ]);

      Swal.fire({
        title: "Success!",
        text: `Reviewer added successfully for Document ${documentName}!`,
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      handleCloseModal();
    } catch (err) {
      console.error("Error adding reviewer:", err);

      Swal.fire({
        title: "Error",
        text: "Failed to add reviewer",
        icon: "error",
      });
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      const email = value.trim().toLowerCase();

      const isDuplicate = reviewers.some(
        (reviewer) => reviewer.email?.trim().toLowerCase() === email,
      );

      if (isDuplicate) {
        Swal.fire({
          icon: "error",
          title: "Duplicate Reviewer",
          text: "This reviewer has already been added.",
        });

        setNewReviewer((prev) => ({
          ...prev,
          email: "",
        }));
        return;
      }
    }

    setNewReviewer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div>
      <br />

      <div className="d-flex justify-content-between align-items-center">
        <h4>
          <strong>Details of Reviewers</strong>
        </h4>
      </div>
      <p>
        If you want to send any reviewer you can add here for this document and
        send {documentName}{" "}
        <Button variant="info" onClick={handleAddReviewerClick}>
          Add Reviewer
        </Button>
      </p>
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Chat</th>
          </tr>
        </thead>
        <tbody>
          {reviewers.length === 0 ? (
            <tr>
              <td colSpan="3" className="text-center">
                No reviewers found
              </td>
            </tr>
          ) : (
            reviewers.map((reviewer, index) => (
              <tr key={reviewer.id ?? index}>
                <td>{reviewer.id ?? index + 1}</td>
                <td>{reviewer.email}</td>
                <td>
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => handleChatClick(reviewer)}
                  >
                    <BsWechat />
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Reviewer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="ReviewerEmail" className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email"
                value={newReviewer.email}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveAddReviewer}>
            Send Invite
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Reviwers;